import { SeatIconTheme } from '../../types';

export const SEAT_ICON_DEFAULT_THEME: SeatIconTheme = {
    size: {
        s: {
            height: 24,
            width: 24,
            iconSize: 10,
        },
        m: {
            height: 36,
            width: 36,
            iconSize: 18,
        },
        l: {
            height: 48,
            width: 48,
            iconSize: 24,
        },
    },
    colors: {
        available: {
            fill: 'common.white',
            border: 'primary.base',
            iconColor: 'primary.base',
        },
        availableHover: {
            fill: 'primary.base',
            border: 'primary.base',
            iconColor: 'primary.tint.100',
        },
        selected: {
            fill: 'primary.base',
            border: 'primary.tint.600',
            iconColor: 'common.white',
        },
        selectedHover: {
            fill: 'primary.tint.300',
            border: 'primary.base',
            iconColor: 'common.white',
        },
        unavailable: {
            fill: 'grey.tint.100',
            border: 'grey.tint.200',
            iconColor: 'grey.tint.200',
        },
    },
};
